class CareTipsSlider extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.care-tips__list');
    this.progressFill = this.querySelector('.care-tips__progress-fill');

    if (!this.list || !this.progressFill) return;

    this.onScroll = this.updateProgress.bind(this);
    this.list.addEventListener('scroll', this.onScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(this.onScroll);
    this.resizeObserver.observe(this.list);

    this.updateProgress();
  }

  updateProgress() {
    const maxScroll = this.list.scrollWidth - this.list.clientWidth;

    if (maxScroll <= 0) {
      this.progressFill.style.width = '100%';
      return;
    }

    const progress = ((this.list.scrollLeft + this.list.clientWidth) / this.list.scrollWidth) * 100;
    this.progressFill.style.width = `${Math.min(100, Math.max(0, progress))}%`;
  }

  disconnectedCallback() {
    this.list?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('care-tips-slider')) {
  customElements.define('care-tips-slider', CareTipsSlider);
}
